import React, { useRef, useEffect,useState } from 'react';
import GeoJSON from 'ol/format/GeoJSON';
import { Vector as VectorSource} from 'ol/source';
import { Style, Circle, Fill, Stroke } from 'ol/style';
import { Vector as VectorLayer} from 'ol/layer';
import LoadingSpinner from './LoadingSpinner';
 
import './Map.css';
 
const Map = props => {
  const [isLoading, setIsLoading] = useState(false);
  const [hiddenPopup, setHiddenPopup] = useState("hiddenPopup");
  const mapRef = useRef();

  useEffect(async () => {
   setIsLoading(true);
   let geojson
    try{    
        const getClass= async ()=>{
            const response = await fetch(process.env.REACT_APP_BACKEND_API_URL+'/download/geojson/'+props.dataset+'/'+props.cs+'/'+props.ontology);
            if (await !response.ok){
                setIsLoading(false);
                props.onError("An error occured during the communication with the SPARQL Endpoint.\n"
            + "Maybe is currently anavailable or does not allow queries");
            }else{
                return await response.json();
            }   
        }

        geojson= await getClass();

        if (geojson.features.length===0){
            setIsLoading(false);
            props.onError("No features found for this class. \n"
            + "Maybe this class uses an unknonown or malformed geo ontology for expressing location");
        }else{
            const vectorSource = new VectorSource({features: new GeoJSON().readFeatures(geojson)});
            var styles = {
                'Point': [new Style({
                    image: new Circle({radius: 4,fill: new Fill({color: [255, 255, 255, 0.5]}),
                    stroke: new Stroke({color: '#cb1d1d', width: 2})
                })
            })]}

            var styleFunction = function(feature, resolution) {
                return styles[feature.getGeometry().getType()];
              };
        
            const vectorLayer = new VectorLayer({
                source: vectorSource,
                style: styleFunction
            });

            const map=new window.ol.Map({
                target: mapRef.current.id,
                layers: [
                    new window.ol.layer.Tile({
                    source: new window.ol.source.OSM()
                }),vectorLayer],
                view: new window.ol.View({
                    projection: 'EPSG:4326',
                    center: window.ol.proj.fromLonLat([0, 0]),
                    zoom: 0
                })
            });

            map.getView().fit(vectorLayer.getSource().getExtent());
            const container = document.getElementById('popup');
            const content_element = document.getElementById('popup-content');
            const closer = document.getElementById('popup-closer');

            closer.onclick = function() {
                overlay.setPosition(undefined);
                closer.blur();
                return false;
            };

            var overlay = new window.ol.Overlay({
                element: container,
                autoPan: true,
                offset: [0, -10]
            });
            map.addOverlay(overlay);

            map.on('click', function(evt){
                var feature = map.forEachFeatureAtPixel(evt.pixel,function(feature, layer) {
                    return feature;
                });
                if (feature) {
                    var geometry = feature.getGeometry();
                    var coord = geometry.getCoordinates();
                    var content = '<a href='+feature.get('uri')+' target=new>' + (feature.get('label')!==undefined ? feature.get('label'):feature.get('uri')) + '</a>';
                    content_element.innerHTML = content;
                    overlay.setPosition(coord);
                }
            });
        }
        setHiddenPopup("ol-popup");
        setIsLoading(false);
    }catch (err){
        setIsLoading(false);
        props.onError("An error occured during the communication with the SPARQL Endpoint.\n"
        + "Maybe is currently unavailable or does not allow queries");
    } 

}, []);
 
  return (
    <React.Fragment>
        {isLoading &&(<div className="center"><LoadingSpinner asOverlay/></div>)} 
        <div
        ref={mapRef}
        className={`map ${props.className}`}
        style={props.style}
        id="map"
        > </div>
         <div id="popup" className="ol-popup" className={hiddenPopup}>
            <a href="#" id="popup-closer" className="ol-popup-closer"></a>
            <div id="popup-content"></div>
        </div>
    </React.Fragment>
  );
};
 
export default Map;